import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, Fragment as _Fragment, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-742cb8d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "el-input-group__prepend"
}
const _hoisted_2 = ["type", "disabled", "readonly", "autocomplete", "tabindex", "aria-label", "placeholder"]
const _hoisted_3 = {
  key: 2,
  class: "el-input__prefix"
}
const _hoisted_4 = {
  key: 3,
  class: "el-input__suffix"
}
const _hoisted_5 = { class: "el-input__suffix-inner" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 3,
  class: "el-input__count"
}
const _hoisted_8 = { class: "el-input__count-inner" }
const _hoisted_9 = {
  key: 4,
  class: "el-input-group__append"
}
const _hoisted_10 = ["tabindex", "disabled", "readonly", "autocomplete", "aria-label", "placeholder"]
const _hoisted_11 = {
  key: 2,
  class: "el-input__count"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      _ctx.type === 'textarea' ? 'el-textarea' : 'el-input',
      _ctx.inputSize ? 'el-input--' + _ctx.inputSize : '',
      {
        'is-disabled': _ctx.inputDisabled,
        'is-exceed': _ctx.inputExceed,
        'el-input-group': _ctx.$slots.prepend || _ctx.$slots.append,
        'el-input-group--append': _ctx.$slots.append,
        'el-input-group--prepend': _ctx.$slots.prepend,
        'el-input--prefix': _ctx.$slots.prefix || _ctx.prefixIcon,
        'el-input--suffix':
          _ctx.$slots.suffix || _ctx.suffixIcon || _ctx.clearable || _ctx.showPassword,
      },
      _ctx.$attrs.class,
    ]),
    style: _normalizeStyle(_ctx.$attrs.style),
    onMouseenter: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.onMouseEnter && _ctx.onMouseEnter(...args))),
    onMouseleave: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args)))
  }, [
    (_ctx.type !== 'textarea')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.$slots.prepend)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "prepend", {}, undefined, true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.type !== 'textarea')
            ? (_openBlock(), _createElementBlock("input", _mergeProps({
                key: 1,
                ref: "input",
                class: "el-input__inner"
              }, _ctx.attrs, {
                type: _ctx.showPassword ? (_ctx.passwordVisible ? 'text' : 'password') : _ctx.type,
                disabled: _ctx.inputDisabled,
                readonly: _ctx.readonly,
                autocomplete: _ctx.autocomplete,
                tabindex: _ctx.tabindex,
                "aria-label": _ctx.label,
                placeholder: _ctx.placeholder,
                onCompositionstart: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCompositionStart && _ctx.handleCompositionStart(...args))),
                onCompositionupdate: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleCompositionUpdate && _ctx.handleCompositionUpdate(...args))),
                onCompositionend: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleCompositionEnd && _ctx.handleCompositionEnd(...args))),
                onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                onFocus: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleFocus && _ctx.handleFocus(...args))),
                onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleBlur && _ctx.handleBlur(...args))),
                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args))),
                onKeydown: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleKeydown && _ctx.handleKeydown(...args)))
              }), null, 16, _hoisted_2))
            : _createCommentVNode("", true),
          (_ctx.$slots.prefix || _ctx.prefixIcon)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _renderSlot(_ctx.$slots, "prefix", {}, undefined, true),
                (_ctx.prefixIcon)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: _normalizeClass(['el-input__icon', _ctx.prefixIcon])
                    }, null, 2))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.getSuffixVisible())
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, [
                  (!_ctx.showClear || !_ctx.showPwdVisible || !_ctx.isWordLimitVisible)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _renderSlot(_ctx.$slots, "suffix", {}, undefined, true),
                        (_ctx.suffixIcon)
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              class: _normalizeClass(['el-input__icon', _ctx.suffixIcon])
                            }, null, 2))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.showClear)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 1,
                        class: "el-input__icon el-icon-circle-close el-input__clear",
                        onMousedown: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"])),
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
                      }, null, 32))
                    : _createCommentVNode("", true),
                  (_ctx.showPwdVisible)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 2,
                        src: _ctx.pwdIconSrc,
                        width: "20",
                        height: "20",
                        class: "toggle-pwd",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handlePasswordVisible && _ctx.handlePasswordVisible(...args)))
                      }, null, 8, _hoisted_6))
                    : _createCommentVNode("", true),
                  (_ctx.isWordLimitVisible)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.textLength) + "/" + _toDisplayString(_ctx.upperLimit), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.validateState)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: _normalizeClass(['el-input__icon', 'el-input__validateIcon', _ctx.validateIcon])
                    }, null, 2))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.$slots.append)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _renderSlot(_ctx.$slots, "append", {}, undefined, true)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock("textarea", _mergeProps({
          key: 1,
          ref: "textarea",
          class: "el-textarea__inner"
        }, _ctx.attrs, {
          tabindex: _ctx.tabindex,
          disabled: _ctx.inputDisabled,
          readonly: _ctx.readonly,
          autocomplete: _ctx.autocomplete,
          style: _ctx.textareaStyle,
          "aria-label": _ctx.label,
          placeholder: _ctx.placeholder,
          onCompositionstart: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleCompositionStart && _ctx.handleCompositionStart(...args))),
          onCompositionupdate: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleCompositionUpdate && _ctx.handleCompositionUpdate(...args))),
          onCompositionend: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handleCompositionEnd && _ctx.handleCompositionEnd(...args))),
          onInput: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
          onFocus: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleFocus && _ctx.handleFocus(...args))),
          onBlur: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.handleBlur && _ctx.handleBlur(...args))),
          onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args))),
          onKeydown: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.handleKeydown && _ctx.handleKeydown(...args)))
        }), null, 16, _hoisted_10)),
    (_ctx.isWordLimitVisible && _ctx.type === 'textarea')
      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.textLength) + "/" + _toDisplayString(_ctx.upperLimit), 1))
      : _createCommentVNode("", true)
  ], 38))
}